import store from '@/store'
import { axios } from '@/api/http'
export function getDictData(codeType, value) {
    if (!value || !codeType) {
        return "参数不能为空"
    }
    var label = "请检查代码类型"
    if (Object.keys(store.getters.getDictDatas).length === 0) return "无字典数据"
    const list = store.getters.getDictDatas[codeType]
    if (!list) return label
    // console.log("1221", list)
    if (list.length > 0) {
        label = "无此代码值"
        list.forEach(l => {
            if (l.value == value) {
                label = l.label
            }
        })
    }
    return label
}

/*
* 根据字典类型查询字典中的配置项
* */
export function getDictList(codeType) {
    if (!codeType) {
        return "参数不能为空"
    }
    if (Object.keys(store.getters.getDictDatas).length === 0) return "无字典数据"
    const list = store.getters.getDictDatas[codeType]
    if (!list) return "请检查代码类型"
    return list
}

/*
* 字典数据 -- 仪器箱号
* */
export const getBoxList = async() => {
    const { data:{ data } }=await axios.get('/admin-api/inspection/instrument-box/simple-list')
    // console.log(data,'仪器箱号');
    const list = data.map((item)=>{ return { name: item.name, value: item.id }}) || []
    return list
    
}   
// export function getBoxList() {
//     const instrumentBox = 'instrument_box'
//     if (Object.keys(store.getters.getDictDatas).length === 0) return [{name: '无字典数据', value: '0'}]
//     const list = store.getters.getDictDatas[instrumentBox]
//     const companyBoxs = store.getters.getCompanyBox
//     if (!list) return [
//         {
//             value: '0',
//             name: '无箱号数据'
//         }
//     ]
//     const boxList = list.map(l => {
//         return {
//             name: l.label,
//             value: l.value
//         }
//     })
//     const indexList = []
//     companyBoxs.forEach(box => {
//         for (var i = 0; i < boxList.length; i++) {
//             if (boxList[i].value == box.instrumentBox) {
//                 if (indexList.length == 0 || indexList.indexOf(i) == -1) {
//                     indexList.push(i)
//                 }
//                 break;
//             }
//         }
//     })
//     const newBoxList = boxList.filter((b, index) => {
//         return indexList.indexOf(index) != -1
//     })
//     console.log("newBoxList", newBoxList);
    
//     return newBoxList

// }


export function getDictListTime(codeType) {
    return new Promise(resolve => {
        if (!codeType) {
            resolve("")
        }
        if (Object.keys(store.getters.getDictDatas).length === 0) resolve("")
        const list = store.getters.getDictDatas[codeType]
        resolve(list)
    })
}
